import { Code } from "book/Code"

export const Article = () => {
	return (
		<>
			<p>Simplify C and native (i.e. assembly, WASM & LLVM) generators by introducing special intermediate representation (IR) in addition to Nice Nodes. Current text-based generators proven to be error prone and code is not very reusable between them.</p>

			<p>It should describe C semantics with some extra metadata for debugging and ABI handling.</p>
		</>
	)
}
